module.exports = __webpack_public_path__ + "img/paul-pro.65142712.jpg";